module.exports = __webpack_public_path__ + "img/akblack.bef0b275.png";